import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { SignalBoConfiguration } from "../../shared/configuration/SignalBoConfiguration";
import { ErrorHandlerService } from "../../shared/services/errorHandler.service";
import { ExecuteService } from "../../shared/services/executeService.service";
import { TradePlan } from "../models/TradePlan";

@Injectable()
export class TradePlanService {
  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService,
    private _signalBoConfiguration: SignalBoConfiguration
  ) {}

  public Create(tradePlan: TradePlan): Observable<TradePlan> {
    const url = `${this._signalBoConfiguration.ApiUrl}api/v1/TradePlan`;
    return this.executeService
    .ExecuteWithToken("post", url, null, tradePlan)
    .pipe(
      catchError(
        this.errorHandler.handleError<TradePlan>(
          "TradePlanService_CreateTradePlan"
        )
      )
    );
  }

  public Get(): Observable<TradePlan[]> {
    const url = `${this._signalBoConfiguration.ApiUrl}api/v1/TradePlan`;
    return this.executeService
      .ExecuteWithToken("get", url)
  }

  public Update(tradePlan: TradePlan): Observable<TradePlan> {
    const url = `${this._signalBoConfiguration.ApiUrl}api/v1/TradePlan`;
    return this.executeService.ExecuteWithApiToken("put", url, null, tradePlan)
    .pipe(
      catchError(
        this.errorHandler.handleError<TradePlan>(
          "TradePlanService_EditTradePlan"
        )
      )
    );
  }

  public Delete(id: string): Observable<boolean> {
    const url = `${this._signalBoConfiguration.ApiUrl}api/v1/TradePlan/${id}`;
    return this.executeService
      .ExecuteWithToken("delete", url)
      .pipe(
        catchError(
          this.errorHandler.handleError<object>("TradePlanService_DeleteTradePlan")
        )
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/services/tradePlan.service.ts